enum IStatusImpediment {
  warning = "WARNING",
  concluded = "CONCLUDED",
}

export default IStatusImpediment;
